import { render, staticRenderFns } from "./DemoCustomDialog.vue?vue&type=template&id=11c99d83"
import script from "./DemoCustomDialog.vue?vue&type=script&lang=js"
export * from "./DemoCustomDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports